<template>
    <div
        v-if="name"
        :class="['avatar-box', myClassName]"
    >
        {{ text }}
    </div>
</template>
<script lang="ts" setup>
import {computed} from 'vue';
const props = defineProps({
    name: {
        type: String,
        required: true,
        default: ''
    },
    myClassName: {
        type: String,
        required: false,
        default: ''
    }
});
const text = computed(() => {
    return props.name.replace('v_', '').trim().substring(0, 1).toUpperCase();
});
</script>
<style scoped lang="scss">
.avatar-box {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 40px;
    border-radius: 16px;
    box-shadow: 1px 2px 6px 0px rgba(0, 102, 255, 0.25);
    background: linear-gradient(275deg, #0075ff 31.6%, #00a3ff 96.64%);
}
.small-size {
    width: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 4px;

    color: #fff;
    text-align: center;
    font-family: PingFang SC;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    text-transform: uppercase;
}
</style>
